import React from 'react';

interface Props {
  label: string;
  score: number;
  maxScore?: number;
}

const ScoreCard: React.FC<Props> = ({ label, score, maxScore = 100 }) => {
  const safeScore = Number.isFinite(Number(score)) ? Number(score) : 0;
  const safeMaxScore = Number.isFinite(Number(maxScore)) && Number(maxScore) > 0 ? Number(maxScore) : 100;
  const pct = Math.max(0, Math.min(100, Math.round((safeScore / safeMaxScore) * 100)));
  const displayScore = Number.isInteger(safeScore) ? safeScore : Math.round(safeScore);
  const toneLabel = safeScore >= 80 ? 'Kuat' : safeScore >= 60 ? 'Cukup' : 'Perlu fokus';
  const tone = safeScore >= 80 ? 'strong' : safeScore >= 60 ? 'average' : 'weak';
  const fillStyle: React.CSSProperties = { width: `${pct}%` };

  return (
    <div className={`iv-score-card iv-score-card--brand iv-score-card--${tone}`}>
      <div className="iv-score-card__header">
        <div className="iv-score-card__copy">
          <span className="iv-score-card__label">{label}</span>
          <span className="iv-score-card__tone">{toneLabel}</span>
        </div>
        <span className="iv-score-card__value">{displayScore}</span>
      </div>
      <div className="iv-score-card__track">
        <div
          className="iv-score-card__fill"
          style={fillStyle}
        />
      </div>
      <div className="iv-score-card__footer">
        <span>0</span>
        <span>{safeMaxScore}</span>
      </div>
    </div>
  );
};

export default ScoreCard;
